import { classNames } from "helpers";
import { PermissionWithAssignment } from "services/api/users/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const USER_PERMISSION_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: PermissionWithAssignment) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.category?.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.user.permission.search.category",
    field: "breadcrumb",
    type: ColumnTypes.string,
  },
  {
    title: "admin.user.permission.search.name",
    field: "name",
    type: ColumnTypes.custom,
    render: (row: PermissionWithAssignment) => {
      return (
        <div>
          
          <div className="text-md">{row.name}</div>
          <div className="text-sm font-light text-slate-500">{row.code}</div>
        </div>
      );
    }
  },

  {
    title: "admin.user.permission.search.description",
    field: "description",
    type: ColumnTypes.string,
  },

  {
    title: "admin.user.permission.search.assigned",
    field: "",
    type: ColumnTypes.custom,
    render: (row: PermissionWithAssignment) => {
      return (
        <span
          className={classNames(
            "flex items-center justify-center w-8 h-8 rounded-full",
            row.isAssigned
              ? "bg-green-100 text-green-600"
              : "bg-gray-100 text-gray-400"
          )}
        >
          {row.isAssigned && (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
        </span>
      );
    },
  },
];
